import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import {
    BillableDeliveryNoteResponse,
    BillableDeliveryNoteStatus
} from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { billingModalDeliveryNotesAddToGridColumnDefs } from '@/modules/billing-module/components/modal/delivery-notes/add-to/config/billing-modal-delivery-notes-add-to-grid.column-defs'
import { billingCommonDeliveryNoteService } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.service'
import { AppliedBillableConceptResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { AgColumnDefinition, IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { store } from '@/store/store'
import { GridUtils } from '@/shared/util/grid-utils'

export class BillingModalDeliveryNotesAddToGridDatasource extends PaginatorLaboratoryDatasource<BillableDeliveryNoteResponse> {
    public readonly appliedBillableConcepts: AppliedBillableConceptResponse[]

    constructor(appliedBillableConcepts: AppliedBillableConceptResponse[]) {
        super(billingCommonDeliveryNoteService, store.getters.labId)
        this.appliedBillableConcepts = appliedBillableConcepts
    }

    public getColumnDefs(): AgColumnDefinition[] {
        return billingModalDeliveryNotesAddToGridColumnDefs()
    }
    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<BillableDeliveryNoteResponse>> {
        const _filterModel: CommonFilterModel = { ...filterModel }
        if (this.appliedBillableConcepts.length) {
            const appliedBillableConcept = this.appliedBillableConcepts[0]

            _filterModel['status'] = GridUtils.getSetFilterModel([BillableDeliveryNoteStatus.GENERATED])

            if (appliedBillableConcept.rate) {
                _filterModel['conceptsAccountingUnit.id'] =
                    GridUtils.getNumberFilterModel('equals', appliedBillableConcept.rate.accountingUnit.id)
            }

            _filterModel['isForAutoInvoice'] =
                GridUtils.getSetFilterModel([`${appliedBillableConcept.isForAutoInvoice}`])

            if (appliedBillableConcept.customer) {
                _filterModel['customer.id'] =
                    GridUtils.getNumberFilterModel('equals', appliedBillableConcept.customer.id)
            } else {
                _filterModel['patient.id'] =
                    GridUtils.getNumberFilterModel('equals', appliedBillableConcept.caseStudy.patient.id)
            }
        }
        return billingCommonDeliveryNoteService.paginator(_filterModel, params, this.laboratoryId)
    }
}
